import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, Label, CardTitle } from "reactstrap";
import "../../../node_modules/bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import { success, info, error, warning, clear } from "toastr";
import * as Yup from "yup";
import Select, { AriaOnFocus } from "react-select";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";
import moment from "moment/moment";
import AsyncSelect from "react-select/async";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  createLedger,
  generateLedgersalesOfficeOutWardStocks,
  getLedgers,
  getPartyApi,
  updateLedgers,
} from "api";
import { Formik, Field, Form, ErrorMessage } from "formik";



class GenerateLedger extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      page: 1,
      totalSize: 100,
      sizePerPage: 100,
      isSubmitTrue: true,
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: 1,
            data: null,
          },
      stockList: [],
      ledgerStatus: "",
      partyList: [],
      selected:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.ledgerDetails.map(
              x => x.salesOfficeOutWardStockId
            )
          : [],
      partyId:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.partyId
          : "",
      status: "",
      toDate:
        props.location.query && props.location.query.isEdit != 1
          ? moment(props.location.query.data.toDate).format("YYYY-MM-DD")
          : moment().endOf("month").format("YYYY-MM-DD"),
      fromDate:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.fromDate
          : moment().startOf("month").format("YYYY-MM-DD"),
      // toDate: "",
      // fromDate: "",
      notes:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.notes
          : "",
      // toDate: moment().subtract(1,"months").endOf('month').format("YYYY-MM-DD"),
      // fromDate: moment().subtract(1,"months").startOf('month').format("YYYY-MM-DD"),
      selectedJangad:
        props.location.query && props.location.query.isEdit != 1
          ? props.location.query.data.ledgerDetails.map(
              x => x.salesOfficeOutWardStock
            )
          : [],
      unSelectedJangad: [],
    };
  }

  async componentDidMount() {
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    this.getStockList();
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    if(data && data.data){
      this.setState({
        partyList: data.data.parties,
      });
    }
   
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  async getStockList() {
    if (this.state.fromDate && this.state.toDate && this.state.partyId) {
      const data = await generateLedgersalesOfficeOutWardStocks({
        page: this.state.page,
        limit: this.state.sizePerPage,
        partyId: this.state.partyId,
        salesOfficeStatus: this.state.status,
        ledgerStatus: this.state.ledgerStatus,
        toDate: this.state.toDate,
        fromDate: this.state.fromDate,
        ledgerId: this.state.props.isEdit != 1 ? this.state.props.data.id : "",
        isParty: true,
      });
      if(data && data.data){
        this.setState({
          totalSize: data.data.count,
          stockList: data.data.salesOfficeOutWardStocks,
        });
      }
      
    }
  }

  getGenerateLedger() {
    return this.state.stockList;
  }

  async generateLedger() {
    if (this.state.props.isEdit == 1) {
      let temp = this.state.selectedJangad.map(x => {
        return {
          mainJangadId: x.mainJangadId,
          salesOfficeOutWardStockId: x.id,
        };
      });
      const data = await createLedger({
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        partyId: this.state.partyId,
        notes: this.state.notes,
        ledgerDetails: temp,
      });
      if(data.success == true){
        this.setState({
          isSubmitTrue: false
        })
      }
    } else {
      let temp = this.state.selectedJangad.map(x => {
        return {
          mainJangadId: x.mainJangadId,
          salesOfficeOutWardStockId: x.id,
        };
      });
      const data = await updateLedgers({
        id: this.state.props.data.id,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        partyId: this.state.partyId,
        notes: this.state.notes,
        ledgerDetails: temp,
      });
      if(data.success == true){
        this.setState({
          isSubmitTrue: false
        })
      }
    }
  }

  getUnSelectedJangad = () => {
    if (this.state.selectedJangad.length == 0) return this.state.stockList;
    else
      return this.state.stockList.filter(x => {
        let temp = this.state.selectedJangad.filter(y => {
          return y.id == x.id;
        });
        return temp.length > 0 ? false : true;
      });
  };

  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.name;
        },
      },
      {
        dataField: "factoryName",
        text: `${this.props.t("Factory Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.jangad.factory.name;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.jangad.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return row.jangad.weight;
        },
      },

      // {
      //   dataField: "cycle",
      //   text: `${this.props.t("Cycle")}`,
      //   formatter(cell, row) {
      //     return row.jangad.cycle;
      //   },
      // },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY hh:mm");
        },
        sort: true,
      },
      {
        dataField: "outwardDate",
        text: `${this.props.t("Outward Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY hh:mm");
        },
        sort: true,
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 100,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [100, 125, 150],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const selectRow = {
      nonSelectable: this.state.props.isEdit == 3 ? this.state.stockList.map((x) => x.id) : [],
      selected: this.state.selected,
      clickToSelect: true,
      mode: "checkbox",
      onSelectAll: (row, isSelected, rowIndex) => { 
        this.setState({
          selected: isSelected.map((x) => x.id),
          selectedJangad: isSelected 
        })
      },
      onSelect: (row, isSelected, rowIndex) => {        
        if (isSelected) {
          this.setState({
            selectedJangad: [...this.state.selectedJangad, row],
            selected: [...this.state.selected, row.id],
          });
        } else {
          this.setState({
            selected: this.state.selected.filter(x => x != row.id),
          });
          this.setState({
            selectedJangad: this.state.selectedJangad.filter(x => {
              return x.mainJangadId != row.mainJangadId;
            }),
          });
        }
      },
    };

    const { SearchBar } = Search;

    //meta title

    const { history } = this.props;
    document.title = "admin-report";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.stockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Ledger")}
                    </h3>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        fromDate: this.state.fromDate || "",
                        toDate: this.state.toDate || "",
                        partyId: this.state.partyId || "",
                        notes: this.state.notes,
                        printStatus: this.state.printStatus || "",
                        approveStatus: this.state.approveStatus || "",
                        paymentStatus: this.state.paymentStatus || "",
                      }}
                      validationSchema={Yup.object().shape({
                        fromDate: Yup.string().required(
                          "This Value is Required"
                        ),
                        toDate: Yup.string().required("This Value is Required"),
                        partyId: Yup.string().required(
                          "This Value is Required"
                        ),
                        notes: Yup.string().max(512).notRequired(),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values, validateForm }) => (
                        <Form className="needs-validation">
                          <Row>
                            <Col className="col-12 mt-3">
                              <Card>
                                <CardBody>
                                  <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                                    <div className="">
                                      <h4 className="text-black fw-bold">
                                        {this.props.t("Generate Ledger")}
                                      </h4>
                                    </div>
                                    <div className="pt-3 pt-xxl-0">
                                      <label
                                        htmlFor="date"
                                        className="fs-5 fw-bold text-black pe-3"
                                      >
                                        {this.props.t("From Date")}:
                                      </label>
                                      <input
                                        type="date"
                                        className="fs-5 text-black border-0    "
                                        name="date"
                                        value={this.state.fromDate}
                                        onChange={e =>
                                          this.setState(
                                            { fromDate: e.target.value },
                                            () => this.getStockList()
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor="date"
                                        className="fs-5 fw-bold px-0 px-md-3 text-black"
                                      >
                                        {this.props.t("To Date")}:
                                      </label>
                                      <input
                                        type="date"
                                        className="fs-5 text-black border-0"
                                        name="date"
                                        value={this.state.toDate}
                                        onChange={e =>
                                          this.setState(
                                            { toDate: e.target.value },
                                            () => this.getStockList()
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="pt-3 pt-xxl-0">
                                      <div className="search-box me-2 mb-2 d-inline-block">
                                        <div className="position-relative">
                                          <label
                                            htmlFor="search"
                                            className="pt-2 fs-5 pe-1 pe-lg-3"
                                          >
                                            {this.props.t("Select Party")}
                                          </label>
                                          <AsyncSelect
                                            id="partyId"
                                            className="officestock-select d-inline-block"
                                            defaultValue={ this.state.props.isEdit != 1 ? {label: this.state.props.data.party.name, value: this.state.props.data.partyId} : { label: "All", value: "" }}
                                            onChange={e => {
                                              this.setState(
                                                {
                                                  partyId: e.value,
                                                  stockList: [],
                                                  page: 1,
                                                  sizePerPage: 10,
                                                },
                                                () => this.getStockList()
                                              );
                                            }}
                                            loadOptions={promiseOptions}
                                            defaultOptions={[
                                              { label: "All", value: "" },
                                              ...this.state.partyList.map(x => {
                                                return {
                                                  value: x.id,
                                                  label: x.name,
                                                };
                                              }),
                                            ]}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                                    <div>
                                      <div className="pt-3 pt-xxl-0">
                                        <p className="d-inline pe-3 fs-5">
                                          {this.props.t("Show")}
                                        </p>
                                        <div className="d-inline">
                                          <SizePerPageDropdownStandalone
                                            className=""
                                            {...paginationProps}
                                          />
                                        </div>

                                        <p className="d-inline ps-3 fs-5">
                                          {this.props.t("entries")}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <Row>
                                    <Col xl="12">
                                      <div className="table-responsive">
                                        <BootstrapTable
                                          remote={true}
                                          onTableChange={() => false}
                                          keyField="id"
                                          responsive
                                          bordered={false}
                                          data={this.state.stockList}
                                          columns={this.columns1}
                                          striped={false}
                                          selectRow={selectRow}
                                          defaultSorted={defaultSorted}
                                          classes={
                                            "table align-middle table-nowrap"
                                          }
                                          headerWrapperClasses={"thead-light"}
                                          {...toolkitProps.baseProps}
                                          {...paginationTableProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row className="mb-5">
                            <div className="col-xl-10 col-12">
                              <div className="row">
                                <Label
                                  htmlFor="notes"
                                  className="col-md-3 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold fs-4">
                                    {this.props.t("Update Ledger Notes")}
                                  </h5>
                                </Label>
                                <div className="col-md-9">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.notes && touched.notes
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={this.state.notes}
                                    onChange={e => {
                                      this.setState({
                                        notes: e.target.value,
                                      });
                                    }}
                                    readOnly={
                                      this.state.props.isEdit == 3
                                        ? true
                                        : false
                                    }
                                    type="text"
                                    as="textarea"
                                    rows="5"
                                    name="notes"
                                  />
                                </div>
                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-xl-2 text-center col-12">
                              <div className="row">
                                <div className="col-lg-12 pt-3">
                                  {(this.state.props.isEdit == 1 && this.state.isSubmitTrue == true) ? (
                                    <>
                                      <Button
                                        type="submit"
                                        color="primary"
                                        className="fs-4 w-xl"
                                        data-target=".bd-example-modal-xl"
                                        data-bs-toggle="modal"
                                        disabled={Array.isArray(this.state.selectedJangad) && this.state.selectedJangad.length}
                                        data-bs-target={
                                          this.state.partyId
                                            ? "#staticBackdrop"
                                            : "#kdfj"
                                        }
                                        onClick={() => {
                                          validateForm()
                                            .then(data => {
                                              console.log(data);
                                              if (
                                                Object.keys(data).length == 0
                                              ) {
                                                this.setState({
                                                  unSelectedJangad:
                                                    this.getUnSelectedJangad(),
                                                });
                                              }
                                            })
                                            .catch(err => console.log(err));
                                        }}
                                      >
                                        Generate Ledger
                                      </Button>
                                    </>
                                  ) : <></>}

                                  <div
                                    className="modal fade fade bd-example-modal-xl"
                                    id="staticBackdrop"
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    aria-labelledby="staticBackdropLabel"
                                    aria-hidden="true"
                                  >
                                    <div className="modal-dialog modal-dialog modal-xl">
                                      <div className="modal-content">
                                        <div className="modal-body">
                                          <div className="text-center py-5">
                                            <img
                                              src="images/dashboard-images/info.svg"
                                              alt="info"
                                            />
                                            <h5
                                              className="modal-title "
                                              id="staticBackdropLabel"
                                            >
                                              {this.props.t(
                                                "Are you sure create your ledger"
                                              )}
                                              ?
                                            </h5>
                                          </div>
                                          <div className="row">
                                            <div className="col-xxl-6 col-12">
                                              <div className="d-flex justify-content-between">
                                                <div></div>
                                                <div className="">
                                                  <label
                                                    htmlFor="date"
                                                    className="fw-bold text-black pe-2"
                                                  >
                                                    {this.props.t("From Date")}
                                                  </label>

                                                  <span>
                                                    {moment(
                                                      this.state.fromDate
                                                    ).format("DD/MM/YYYY")}
                                                  </span>
                                                </div>
                                                <label
                                                  htmlFor="date"
                                                  className="fw-bold text-black pe-2"
                                                >
                                                  {this.props.t("To Date")}
                                                </label>
                                                <span>
                                                  {moment(
                                                    this.state.toDate
                                                  ).format("DD/MM/YYYY")}
                                                </span>
                                              </div>
                                              <div className="table-responsive">
                                                <table className="table table-bordered ">
                                                  <thead>
                                                    <tr>
                                                      <th scope="col">
                                                        {this.props.t("SR No.")}
                                                      </th>
                                                      <th scope="col">
                                                        {this.props.t(
                                                          "Selected Jangad Id"
                                                        )}
                                                      </th>
                                                      <th scope="col">
                                                        {this.props.t(
                                                          "Inward Date"
                                                        )}
                                                      </th>
                                                      <th scope="col">
                                                        {this.props.t(
                                                          "Outward Date"
                                                        )}
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {this.state.selectedJangad.map(
                                                      (x, index) => {
                                                        return (
                                                          <tr key={x.id}>
                                                            <th scope="row">
                                                              {index + 1}
                                                            </th>
                                                            <td>
                                                              {x.mainJangadId}
                                                            </td>
                                                            <td>
                                                              {moment(
                                                                x.mainJangad
                                                                  .createdAt
                                                              ).format(
                                                                "DD/MM/YYYY"
                                                              )}
                                                            </td>
                                                            <td>
                                                              {moment(
                                                                x.createdAt
                                                              ).format(
                                                                "DD/MM/YYYY"
                                                              )}
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                            <div className="col-xxl-6">
                                              <div className="">
                                                <div className="table-responsive">
                                                  <table className="table table-bordered px-5">
                                                    <thead>
                                                      <tr>
                                                        <th scope="col">
                                                          {this.props.t(
                                                            "SR No."
                                                          )}
                                                        </th>
                                                        <th scope="col">
                                                          {this.props.t(
                                                            "Unselected Jangad Id"
                                                          )}
                                                        </th>
                                                        <th scope="col">
                                                          {this.props.t(
                                                            "Inward Date"
                                                          )}
                                                        </th>
                                                        <th scope="col">
                                                          {this.props.t(
                                                            "Outward Date"
                                                          )}
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.unSelectedJangad.map(
                                                        (x, index) => {
                                                          return (
                                                            <tr key={x.id}>
                                                              <th scope="row">
                                                                {index + 1}
                                                              </th>
                                                              <td>
                                                                {x.mainJangadId}
                                                              </td>
                                                              <td>
                                                                {moment(
                                                                  x.mainJangad
                                                                    .createdAt
                                                                ).format(
                                                                  "DD/MM/YYYY"
                                                                )}
                                                              </td>
                                                              <td>
                                                                {moment(
                                                                  x.createdAt
                                                                ).format(
                                                                  "DD/MM/YYYY"
                                                                )}
                                                              </td>
                                                            </tr>
                                                          );
                                                        }
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="modal-footer mx-auto">
                                          <Button
                                            color="white"
                                            data-bs-toggle="modal"
                                            data-bs-dismiss="modal"
                                            className="fs-4 w-xl text-primary"
                                            type="submit"
                                            onClick={() => {
                                              if (
                                                this.state.selectedJangad
                                                  .length > 0
                                              ) {
                                                this.generateLedger();
                                              } else {
                                                warning(
                                                  "Please Select Minimum one Jangad"
                                                );
                                              }
                                            }}
                                          >
                                            Confirm
                                          </Button>
                                          <Button
                                            data-bs-target="#exampleModalToggle"
                                            data-bs-toggle="modal"
                                            data-bs-dismiss="modal"
                                            className="fs-4 w-xl"
                                            color="primary"
                                          >
                                            Cancel
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {(this.state.props.isEdit == 2 && this.state.isSubmitTrue == true) ?  (
                                  <>
                                    <div className="col-lg-12 pt-3">
                                      <Button
                                        type="submit"
                                        color="primary"
                                        className="fs-4 w-xl"
                                        data-target=".bd-example-modal-xl"
                                        data-bs-toggle="modal"
                                        data-bs-target={
                                          this.state.partyId
                                            ? "#staticBackdrop"
                                            : "#kdfj"
                                        }
                                        onClick={() => {
                                          validateForm()
                                            .then(data => {
                                              console.log(data);
                                              if (
                                                Object.keys(data).length == 0
                                              ) {
                                                this.setState({
                                                  unSelectedJangad:
                                                    this.getUnSelectedJangad(),
                                                });
                                              }
                                            })
                                            .catch(err => console.log(err));
                                        }}
                                      >
                                        Update Ledger
                                      </Button>
                                    </div>
                                  </>
                                ) : <></>}
                              </div>
                            </div>
                          </Row>
                          <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                            <div className="">
                              <h5>
                                {this.props.t("Showing")}{" "}
                                {(this.state.page - 1) *
                                  this.state.sizePerPage +
                                  1}{" "}
                                -{" "}
                                {this.state.totalSize < this.state.sizePerPage
                                  ? this.state.totalSize
                                  : this.state.sizePerPage * this.state.page >=
                                    this.state.totalSize
                                  ? this.state.totalSize
                                  : this.state.sizePerPage *
                                    this.state.page}{" "}
                                of {this.state.totalSize}
                              </h5>
                            </div>
                            <div className="ms-auto">
                              <PaginationListStandalone {...paginationProps} />
                            </div>
                          </Col>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(GenerateLedger);
